import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetApiRequest } from '../../services/api';

export const fetchUsers = createAsyncThunk(
  'users/fetchUsers',
  async ({ page = 1, search = '' }, { rejectWithValue }) => {
    try {
      const response = await GetApiRequest('admin/users', {
        page,
        search: search || undefined,
      });

      const responseData = response?.data?.data || {};
      const usersList = responseData.users || [];
      const paginationData = responseData.pagination || { page: 1, limit: 10, total: 0, pages: 1 };

      return {
        users: usersList,
        pagination: {
          currentPage: paginationData.page || 1,
          totalPages: paginationData.pages || 1,
          totalUsers: paginationData.total || 0,
          limit: paginationData.limit || 10,
          hasMore: (paginationData.page || 1) < (paginationData.pages || 1)
        }
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Failed to load users');
    }
  }
);

const initialState = {
  users: [],
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalUsers: 0,
    limit: 20,
    hasMore: false
  },
  page: 1,
  search: '',
  hasLoaded: false,
  lastFetchedPage: null,
  lastFetchedSearch: ''
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
      state.page = 1;
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.users;
        state.pagination = action.payload.pagination;
        state.hasLoaded = true;
        state.lastFetchedPage = action?.meta?.arg?.page ?? state.pagination.currentPage;
        state.lastFetchedSearch = action?.meta?.arg?.search ?? '';
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setPage, setSearch, clearError } = usersSlice.actions;
export default usersSlice.reducer;
